var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5748 9.8894L9.36038 7.67498C9.26043 7.57503 9.12494 7.5195 8.98279 7.5195H8.62076C9.23378 6.73546 9.59803 5.7493 9.59803 4.67652C9.59803 2.1245 7.53021 0.0566711 4.97819 0.0566711C2.42616 0.0566711 0.358337 2.1245 0.358337 4.67652C0.358337 7.22854 2.42616 9.29637 4.97819 9.29637C6.05097 9.29637 7.03713 8.93211 7.82117 8.31909V8.68113C7.82117 8.82328 7.8767 8.95876 7.97665 9.05871L10.1911 11.2731C10.3998 11.4819 10.7374 11.4819 10.944 11.2731L11.5726 10.6446C11.7814 10.4358 11.7814 10.0982 11.5748 9.8894ZM4.97819 7.5195C3.40788 7.5195 2.1352 6.24905 2.1352 4.67652C2.1352 3.10622 3.40566 1.83354 4.97819 1.83354C6.54849 1.83354 7.82117 3.10399 7.82117 4.67652C7.82117 6.24682 6.55071 7.5195 4.97819 7.5195Z",
    fill: "#8A8587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b9edbe38d2a2abdb22992a4bae495846.svg";
export { ForwardRef as ReactComponent };